import { useResponseHandler } from '@hooks/useResponseHandler';
import { useSession } from '@hooks/useSession';

import { useListTerraActivitiesQuery } from 'generated/activity.generated';
import type { TerraActivityFilters } from 'generated/types';

export const useGetTerraActivities = (filters?: TerraActivityFilters) => {
  const { handleError } = useResponseHandler();
  const {
    state: { activeProfile },
  } = useSession();
  const vitall_patient_id = activeProfile?.vitall_patient_id ?? '';
  const response = useListTerraActivitiesQuery({
    variables: {
      input: {
        vitall_patient_id,
        filters: {
          ...filters,
        },
      },
    },
    skip: !vitall_patient_id,
  });
  const { error } = response;
  handleError(error);
  return { ...response, data: response.data?.listTerraActivities };
};
